export enum AccessRegistrationActions {}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const actions: any = {}

export default actions
